module.exports = __webpack_public_path__ + "img/imgImgHome07.4a5d0dbc.svg";